import { createBrowserRouter } from 'react-router-dom';

import App from '@/App';
import DashboardPage from '@/features/dashboard/DashboardPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
    ],
  },
]);

export default router;
